var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('error-group',{attrs:{"validator":_vm.validations,"name":"field"}},[_c('v-radio-group',{attrs:{"value":_vm.value,"disabled":_vm.readonly,"label":_vm.field.label,"color":"#005c7b"},on:{"change":_vm.onChange}},_vm._l((_vm.field.options),function(item,index){return _c('v-radio',{key:index,attrs:{"label":item,"value":item}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }